import { connect } from 'react-redux'
import { compose } from 'redux'
import { updateNewspaperItem } from '../../../actions'
import toJS from '../../../hoc/toJS'
import hasSingleMovie from '../../../hoc/hasSingleMovie'
import ListItemMovieContainer from './ListItemMovieContainer'
import ListItemMovieNewspaperEditButton from '../presents/ListItemMovieNewspaperEditButton'
import getData from '../../../functions/getData'
import { PROGRAM_ATTRIBUTES, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_COMP_MOVIES_ITEMS, PROGRAM_CORTEC_MOVIES_ITEMS, PROGRAM_DIESEL_MOVIES_ITEMS, PROGRAM_KH_MOVIES_ITEMS, PROGRAM_MARSX_MOVIES_ITEMS, PROGRAM_MOVIEEXTENSIONS_ITEMS, PROGRAM_MOVIEMAPPING_ITEMS, PROGRAM_PY_MOVIES_ITEMS, PROGRAM_VISTA_MOVIES_ITEMS } from '../../../constants/state'
import getMovieExtensions from '../../../functions/getMovieExtensions'
import getSourceMovies from '../../../functions/getSourceMovies'
import ListItemNoDataContainer from './ListItemNoDataContainer'

const mapStateToProps = (state, ownProps) => ({
    movies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    movieExtensionsItems: getData(state, PROGRAM_MOVIEEXTENSIONS_ITEMS),
    movieMappings: getData(state, PROGRAM_MOVIEMAPPING_ITEMS),
    pyMovies: getData(state, PROGRAM_PY_MOVIES_ITEMS),
    dieselMovies: getData(state, PROGRAM_DIESEL_MOVIES_ITEMS),
    khMovies: getData(state, PROGRAM_KH_MOVIES_ITEMS),
    compMovies: getData(state, PROGRAM_COMP_MOVIES_ITEMS),
    cortecMovies: getData(state, PROGRAM_CORTEC_MOVIES_ITEMS),
    vistaMovies: getData(state, PROGRAM_VISTA_MOVIES_ITEMS),
    marsxMovies: getData(state, PROGRAM_MARSX_MOVIES_ITEMS),
    attributes: getData(state, PROGRAM_ATTRIBUTES)
})

const mapDispatchToProps = (dispatch) => ({
    onUpdate: (itemData) => {
        dispatch(updateNewspaperItem('choosenMovies', itemData))
    }
})

const enhance = compose(
    hasSingleMovie(),
    toJS()
)

const MovieContainer = ({itemType, movieData, isSelected, additionalButton, onDelete}) => {
    return <ListItemMovieContainer
        itemType={itemType}
        itemData={movieData}
        additionalClass=''
        isSelected={isSelected}
        additionalButton={additionalButton}
        pathnameEdit={false}
        onDelete={onDelete}
    />
}

const EnhancedMovieContainer = enhance(MovieContainer)

const ListItemMovieNewspaperContainer = ({
    itemType,
    itemData, 
    isSelected,
    onDelete, 
    onUpdate,
    movies,
    cinemaId,
    movieMappings,
    movieExtensionsItems,
    attributes,
    khMovies, 
    compMovies, 
    pyMovies, 
    dieselMovies, 
    vistaMovies,
    marsxMovies,
    cortecMovies
}) => {
    if(!itemData || !itemData.id || !itemData.movieId) {
        return <ListItemNoDataContainer onDelete={onDelete} />
    } else {
        const movieExtension = {}
        const movieExist = movies && movies.hasOwnProperty(itemData.movieId) && movies[itemData.movieId]
        const sourceMoviesByItemId = movieExist && !_.isEmpty(movieMappings) ? movieMappings[itemData.movieId].source : null
        const cliMovieRelevantSourceMovies = getSourceMovies(sourceMoviesByItemId, khMovies, compMovies, pyMovies, dieselMovies, cortecMovies, vistaMovies, marsxMovies)
        getMovieExtensions(cinemaId, movieExtension, movieExtensionsItems, cliMovieRelevantSourceMovies)
        const cinemaMovieExtension = movieExtension[cinemaId]
        const cinemaTechnicalAttributes = attributes[cinemaId] && attributes[cinemaId].technical ? attributes[cinemaId].technical : null

        return <EnhancedMovieContainer 
            itemType={itemType}
            itemData={itemData}
            movieId={itemData.movieId}
            isSelected={isSelected}
            additionalButton={<ListItemMovieNewspaperEditButton
                itemData={itemData}
                cinemaMovieExtension={cinemaMovieExtension}
                cinemaTechnicalAttributes={cinemaTechnicalAttributes}
                onUpdate={onUpdate}
            />}
            onDelete={onDelete}
        />
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(ListItemMovieNewspaperContainer)